import React from 'react';
import MirrorIcon from '@mui/icons-material/Flip';
import MoveIcon from '@mui/icons-material/OpenWith';
import RotateIcon from '@mui/icons-material/WifiProtectedSetup';
import { Button, ButtonGroup, ButtonGroupProps } from '@mui/material';
import { createSelector } from 'reselect';

import { useAppDispatch, useAppSelector } from '../../../components/hooks';
import { useAppMonitor } from '../../../monitor';
import { beginTransformation } from '../../../store/actions/layout/transformationActions';
import { isLayoutModeViewOnly } from '../../../store/selectors/layoutModeSelectors';
import { propertiesShouldBeViewOnly } from '../../../store/selectors/viewOnlyModeSelectors';
import { getCurrentTransformationTargets } from '../selectors';

const shouldBeViewOnly = createSelector(
  [propertiesShouldBeViewOnly, isLayoutModeViewOnly],
  (viewOnlyProperties, viewOnlyLayout) => viewOnlyProperties || viewOnlyLayout,
);

export function TransformationButtons(props: ButtonGroupProps) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const viewOnly = useAppSelector(shouldBeViewOnly);

  const targets = useAppSelector(getCurrentTransformationTargets);
  if (targets == null) return null;

  return (
    <ButtonGroup fullWidth {...props}>
      <Button
        disabled={viewOnly}
        startIcon={<MoveIcon />}
        onClick={() => {
          monitor.recordInteraction('Transformation button clicked', { actionType: 'movement' });
          dispatch(beginTransformation('movement'));
        }}
      >
        Move
      </Button>

      <Button
        disabled={viewOnly}
        startIcon={<RotateIcon />}
        onClick={() => {
          monitor.recordInteraction('Transformation button clicked', { actionType: 'rotation' });
          dispatch(beginTransformation('rotation'));
        }}
      >
        Rotate
      </Button>

      <Button
        disabled={viewOnly}
        startIcon={<MirrorIcon />}
        onClick={() => {
          monitor.recordInteraction('Transformation button clicked', { actionType: 'mirror' });
          dispatch(beginTransformation('mirror'));
        }}
      >
        Mirror
      </Button>
    </ButtonGroup>
  );
}
